import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import PeopleTables from './PeopleTables'
import SectionsTable from './SectionsTable'

const PeopleContainer = props => {
  return (
    <div className="p-3">
      <h1 className="me-course-title">{props.courseTitle}</h1>
      <h2 className="me-page-title">People</h2>
      <SectionsTable tableName="section" page={props.sectionPage} />
      <PeopleTables />
    </div>
  )
}

PeopleContainer.propTypes = {
  courseTitle: PropTypes.string,
  coursenum: PropTypes.string,
  sectionPage: PropTypes.number,
  enforceAccessDays: PropTypes.number,
}

const mapStateToProps = state => {
  return {
    courseTitle: state.courseTitle,
    coursenum: state.coursenum,
    enforceAccessDays: state.enforceAccessDays,
    sectionPage: state.currentSectionPage,
  }
}

export default connect(mapStateToProps)(PeopleContainer)
